<template>
  <div>
    <v-card class="card--flex-toolbar">
      <v-card-title class="grey lighten-4">
        <div class="greyDarken1--text font-weight-medium">
          {{$t('page.save.title')}}
        </div>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-card class="card--flex-toolbar">
          <v-layout row wrap class="mt-3">
            <v-flex xs6>
              <!-- Slug -->
              <v-text-field
                id="slug"
                :label="$t('page.save.form.slug')"
                color="primary"
                name="slug"
                :rules="[
                  rules.required,
                  rules.min_length(3),
                  rules.max_length(50),
                ]"
                counter="50"
                prepend-icon="mdi-alphabetical"
                type="text"
                @keyup="slugify"
                v-model="page.slug"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-5">
            <v-flex xs12>
              <v-card elevation="2" tile class="mb-4">
                <v-card-title>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-tabs
                          background-color="transparent"
                          color="basil"
                          grow
                          v-model="widget_language"
                      >
                        <v-tab
                          v-for="language in enabledLanguages" :key="language.value"
                        >
                            {{ language.text }}
                        </v-tab>
                      </v-tabs>
                    </v-flex>
                  </v-layout>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-tabs-items v-model="widget_language">
                    <v-tab-item
                        v-for="language in enabledLanguages"
                        :key="language.name"
                    >
                      <v-card flat>
                        <v-card-text>
                          <!-- Title -->
                          <v-text-field
                            id="title"
                            :label="$t('page.save.form.title') + ' (' + language.text + ')'"
                            name="title"
                            :rules="[
                              rules.min_length(3),
                              rules.max_length(250),
                            ]"
                            counter="250"
                            color="primary"
                            prepend-icon="$vuetify.icons.rms_agreement"
                            type="text"
                            v-model="page.title[language.value]"
                          ></v-text-field>
                          <!-- Description -->
                          <div class="mt-2">
                            <v-layout class="greyDarken1--text">
                              {{ $t('rms.field.description.label') + ' (' + language.text + ')' }} 
                              <v-spacer></v-spacer>
                              <v-tooltip slot="append" color="white" top>
                                <v-icon slot="activator">$vuetify.icons.rms_help_circle</v-icon>
                                <span class="greyDarken3--text body-1">
                                  {{ $t('page.save.form.description.tooltip') + ' (' + language.text + ')'}}
                                </span>
                              </v-tooltip>
                            </v-layout>
                            <TextEditor v-model="page.description[language.value]" />
                          </div>
                          <v-checkbox v-model="page.published" color="primary">
                            <template v-slot:label>
                              <div v-if="page.published">{{ $t('screener.save.form.published') }}</div>
                              <div v-else>{{ $t('screener.save.form.unpublished') }}</div>
                            </template>
                            <template v-slot:append>
                              <v-tooltip top color="white">
                                <template v-slot:activator="{on}">
                                  <v-icon v-on="on">mdi-information-outline</v-icon>
                                </template>
                                <div
                                  class="grey--text text--darken-3 body-1"
                                >{{ $t('page.save.form.published.tooltip') }}</div>
                              </v-tooltip>
                            </template>
                          </v-checkbox>
                        </v-card-text>
                      </v-card>
                      <!-- Meta Data -->
                      <v-card flat>
                        <v-card-title class="grey lighten-4">
                          <div class="greyDarken1--text font-weight-medium">Meta Data</div>
                        </v-card-title>
                        <v-card-text>
                          <!--Meta  Title -->
                          <v-text-field
                            id="meta title"
                            :label="$t('page.save.form.meta_title') + ' (' + language.text + ')'"
                            name="meta title"
                            :rules="[
                              rules.min_length(3),
                              rules.max_length(250),
                            ]"
                            counter="250"
                            color="primary"
                            type="text"
                            v-model="page.meta_title[language.value]"
                          ></v-text-field>
                          <!-- Meta keyword -->
                          <v-text-field
                            id="meta keyword"
                            :label="$t('page.save.form.meta_keyword') + ' (' + language.text + ')'"
                            color="primary"
                            name="meta keyword"
                            :rules="[
                              rules.min_length(3),
                              rules.max_length(50),
                            ]"
                            counter="50"
                            type="text"
                            v-model="page.meta_keyword[language.value]"
                          ></v-text-field>
                          <!-- Meta Description -->
                          <v-text-field
                            id="meta description"
                            :label="$t('page.save.form.meta_description') + ' (' + language.text + ')'"
                            color="primary"
                            name="meta description"
                            :rules="[
                              rules.min_length(3),
                              rules.max_length(250),
                            ]"
                            counter="250"
                            type="text"
                            v-model="page.meta_description[language.value]"
                          ></v-text-field>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn
              @click="$router.push({name: 'page.list'})"
              color="grey"
              dark
            >{{ $t('rms.button.cancel') }}</v-btn>
            <v-btn
              v-if="page.id != undefined"
              @click="save('update')"
              color="secondary"
              dark
            >{{ $t('rms.button.update') }}</v-btn>
            <v-btn v-else @click="save('create')" color="secondary" dark>
              {{
              $t('rms.button.create')
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card-text>
    </v-card>
   
  </div>
</template>

<script>
import DEFINES from "@/defines";
import rules from "@/validation";
import i18n from "@/i18n";
import { mapState, mapGetters } from "vuex";
import TextEditor from "@/components/TextEditor";
// import from local copy

export default {
  name: "PageSave",
  data() {
    return {
      rules,
      page: {
        title: {
          en : '',
          es : '',
          he : '',
          ru : '',
          fr : '',
          it : '',
          cs : '',
          de : ''
        },
        slug: null,
        description: {
          en : '',
          es : '',
          he : '',
          ru : '',
          fr : '',
          it : '',
          cs : '',
          de : ''
        },
        meta_title: {
          en : '',
          es : '',
          he : '',
          ru : '',
          fr : '',
          it : '',
          cs : '',
          de : ''
        },
        meta_keyword: {
          en : '',
          es : '',
          he : '',
          ru : '',
          fr : '',
          it : '',
          cs : '',
          de : ''
        },
        meta_description: {
          en : '',
          es : '',
          he : '',
          ru : '',
          fr : '',
          it : '',
          cs : '',
          de : ''
        },
        published: false,
      },
      widget_language:0,
      registration_link: null
    };
  },
  components: {
    TextEditor
  },
  computed: {
    ...mapState({
      company: (state) => state.company.company,
    }),
    ...mapGetters("company", {
      selected_company_id: "getSelected"
    }),
    enabledLanguages() {
      if (this.company) {
          return ('enabled_language_support' in this.company.custom_properties) ? this.company.custom_properties.enabled_language_support : this.i18n_locale; 
      }else{
          return this.i18n_locale
      }
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    async get() {
      if (this.$route.params.page_id == undefined) {
        return;
      }
      let result = await this.$store.dispatch("page/get", {
        id: this.$route.params.page_id
      });
      var page = Object.assign({}, result);
      this.page = page;
    },

    slugify() {
      if (this.page.slug) {
        this.page.slug = this.page.slug.split(" ").join("-");
      }
    },

    async save(operation) {
      // if (!this.$refs.form.validate()) {
      //   return false;
      // }
      try {
        var response = await this.$store.dispatch(
          "page/" + operation,
          this.page
        );

        this.$router.push({
          name: "page.list",
          params: {
            company_id: this.selected_company_id
          }
        });
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("page.save.success.message"),
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    }
  }
};
</script>